/* eslint-disable default-param-last */
import { HYDRATE } from 'next-redux-wrapper';
import merge from 'deepmerge';

export const types = {
  SET_CART: 'CART/SET_CART',
  PURCHASE: 'CART/PURCHASE',
  /* nextjs */
  HYDRATE: 'MAIN/HYDRATE',
};

export const actions = {
  setCart: (cart) => ({ type: types.SET_CART, cart }),
  purchase: (data) => ({ type: types.PURCHASE, ...data }),
};

const initialState = {};

function reducer(state = { ...initialState }, action) {
  switch (action.type) {
    case HYDRATE: {
      const { cart } = action.payload;
      /* neceisto preservar lo que viene del sever excepto los filtros */
      const nextState = merge(state, cart);
      return nextState;
    }
    case types.SET_CART: {
      const { cart } = action;
      return {
        ...cart,
      }
    }
    default:
      return state;
  }
}

export default reducer;
